import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Interface that components must implement to use the unsaved changes guard.
 * The component should return:
 * - true: Navigation is allowed
 * - false: Navigation is blocked
 * - Observable<boolean>: Navigation waits for the observable to emit
 */
export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

/**
 * Guard that checks if a component has unsaved changes before allowing navigation.
 * The component must implement the CanComponentDeactivate interface.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  // If the component doesn't implement canDeactivate, allow navigation
  if (!component || !component.canDeactivate) {
    return true;
  }

  return component.canDeactivate();
};
